import CartesianConfiguration from "./configurations/cartesian_configuration"

export default class CartesianChartResponse {
    constructor(attributes) {
        this.configuration = new CartesianConfiguration({
            x: attributes.x || [],
            y: attributes.y || [],
            layers: attributes.layers || [],
            options: attributes.options || {}
        })
    }

    get options() {
        return this.configuration.options
    }

    get layers() {
        return this.configuration.layers
    }
}
